import React from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import messages from '../messages';
import { TryLozenge, TitleWrapper } from './styled';

type ImprovementTitleProps = {
	isPreExpand: boolean;
};
const ProjectPagesImprovementTitle = ({
	intl,
	isPreExpand,
}: ImprovementTitleProps & WrappedComponentProps) => {
	return (
		<TitleWrapper>
			{intl.formatMessage(messages.title)}
			{isPreExpand && (
				<TryLozenge>
					<Lozenge appearance="inprogress">{intl.formatMessage(messages.tryLozenge)}</Lozenge>
				</TryLozenge>
			)}
		</TitleWrapper>
	);
};

export default injectIntl(ProjectPagesImprovementTitle);
